//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { PurchaseOrderDocument } from '../../graphql/entities';
import getIn from '../../components/connectedForm/utils/getIn';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { FilterOperation, IFilterInput } from '../../graphql/schema/p4types';

const PURCHASE_ORDER_DOCUMENT_WORKSPACE_COLUMN_OVERRIDES = {
  //Doesn't seem to be applying to the 'filters' dropdown (Just columns)???
  'purchaseOrder.orderNumber': {
    name: 'Order Number',
    key: 'purchaseOrder.orderNumber',
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 0 },
    },
  },
};

const PURCHASE_ORDER_DOCUMENT_WORKSPACE_FIELD_NAMES = [
  'documentNumber',
  'documentSuffix',
  'purchaseOrder.orderNumber',
  'supplier.name',
  'author.name',
];

const { workspace, type, title } = PurchaseOrderDocument;

const getFilterFromProps: (props: any) => Array<IFilterInput> = (props) => {
  const batch = getIn(props, 'match.params.batch');
  return batch
    ? [
        {
          filterOperation: FilterOperation.Equals,
          filterParameters: {
            field: 'batchId',
            value: batch,
          },
        },
      ]
    : [];
};

const PurchaseOrderDocumentWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, PurchaseOrderDocument, {
    columns: PURCHASE_ORDER_DOCUMENT_WORKSPACE_FIELD_NAMES,
    columnOverrides: PURCHASE_ORDER_DOCUMENT_WORKSPACE_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    filters: getFilterFromProps(props),
  });

  return (
    <Workspace
      ref={props.setWorkspaceRef}
      entityType={type}
      title={title}
      defaultQuery={workspace}
      entity={PurchaseOrderDocument}
      {...workspaceProps}
      {...props}
    />
  );
};

export default PurchaseOrderDocumentWorkspace;
